<script lang="ts">
  import { onMount } from 'svelte';
  import ReportGroupDetail from '../components/ReportGroupDetail.svelte';
  import ReportGroupList from '../components/ReportGroupList.svelte';
  import Notice from '../lib/ui/Notice.svelte';
  import Toast from '../lib/ui/Toast.svelte';
  import { ReportDefinitionsBoard } from '../lib/report-definitions-board.svelte';

  interface Props {
    onUnauthorized: () => void;
  }

  let { onUnauthorized }: Props = $props();

  const board = new ReportDefinitionsBoard(() => onUnauthorized());

  onMount(() => {
    void board.load();
    void board.loadTenants();
    return () => board.undo.dismiss();
  });
</script>

<section class="reports">
  {#if board.error}
    <Notice tone="danger">{board.error}</Notice>
  {/if}

  {#if board.openedGroup}
    {#key board.openedGroup.id}
      <ReportGroupDetail {board} group={board.openedGroup} />
    {/key}
  {:else}
    <ReportGroupList {board} />
  {/if}
</section>

{#if board.undo.current}
  <Toast label={board.undo.current.label} actionLabel="Desfazer" onAction={() => board.undo.revert()} />
{/if}

<style>
  .reports {
    display: flex;
    flex-direction: column;
    gap: var(--space-4);
  }
</style>
